import { useLayoutEffect, useEffect } from 'react';
import { isBrowser } from './is-browser.js';
var useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect;
export { useIsomorphicLayoutEffect };